<div class="field-form-control" *ngIf="control">
  <label [for]="id" *ngIf="label" class="form-label" [style.color]="labelColor" [class.required]="isRequired">
    {{ label }}
  </label>
  @if (mask !== InputMaskTypes.PHONE) {
    <input class="form-control"
      [required]="isRequired"
      [type]="'text'"
      [id]="id"
      [formControl]="control"
      [placeholder]="placeholder"
      [mask]="mask"
      (blur)="onBlur($event)"
      [dropSpecialCharacters]="dropSpecialCharacters"
    />
  } @else {
    <div class="input-group">
      <app-phone-country-select
        [id]="id + 'Country'"
        [(country)]="phoneCountry"
      ></app-phone-country-select>
      <input class="form-control"
        [required]="isRequired"
        [type]="'text'"
        [id]="id"
        [formControl]="control"
        [placeholder]="placeholder"
        [country]="phoneCountry"
        (countryChange)="phoneCountry = $event"
        [phoneKind]="phoneKind"
        (blur)="onBlur($event)"
        BrPhoneMask
        [attr.maxlength]="phoneFieldMaxLength"
      />
    </div>
  }

  <app-validation-errors *ngIf="control.touched"
    [customErrorMessages]="customErrorMessages"
    [errors]="control.errors">
  </app-validation-errors>
</div>
